var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-image"},[_c('div',{staticClass:"mx-4 pt-5 pb-5"},[_c('Bar',{staticClass:"bg-color",attrs:{"id":"my-chart-id","options":_vm.chartOptions,"data":_vm.chartData,"height":_vm.chartHeight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }